module.exports = __webpack_public_path__ + "static/media/JDM_beats1.520817b8.png";